import React, { useRef, useState, useEffect, useCallback } from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import isUndefined from 'lodash/isUndefined';

// CONTEXT
import { useLogContext } from '../helpers/logContext';

// CORE COMPONENTS
import Button from 'core/tools/Button';
import Form from 'core/form/Form';
import Sprite from 'core/tools/Sprite'

// STYLES
import styles from './searchTool.module.scss';

// MAIN COMPONENT
export const SearchTool = ({
  name,
  label = 'entries',
  onChange
}) => {

  // CONTEXT
  const { logs: { [name]: { fetch } = {} } } = useLogContext() || {};

  // STATE
  const [ show, setShow ] = useState();
  const [ search, setSearch ] = useState();
  const [ dirty, setDirty ] = useState(false);

  // REFS
  const inputRef = useRef();

  // CALLBACKS
  const handleSubmit = useCallback(fieldName => {
    fetch({
      params: {
        fieldName: isUndefined(fieldName) ? search : fieldName
      },
      loadingMessage: `Searching ${label}`
    })
    onChange(isUndefined(fieldName) ? search : fieldName);
  }, [label, fetch, search, onChange]);

  const handleClick = () => {
    if (!!search) {
      handleSubmit();
      setDirty(true);
    } else {
      if (dirty) {
        handleSubmit('');
        setDirty(false);
      } else {
        setShow(!show)
        setSearch('');
      }
      if (!show) inputRef.current.focus();
    }
  };

  const handleReset = useCallback(
    () => {
      if (dirty) handleSubmit('');
      setSearch('');
      setDirty(false);
    },
    [dirty, handleSubmit]
  );

  // Reset on unmount
  // TODO: Only do it if search truthy
  useEffect(() => {
    return () => {
      fetch()
    }
  }, [fetch]);

  // RENDER
  return (
    <Form.Control
      className={clsx(
        styles.input,
        !!show && styles.show
      )}
      value={search}
      placeholder='Enter field name to search'
      onKeyDown={e => {
        if (e.code === 'Enter') {
          handleSubmit();
          if (search) setDirty(true);
          else setDirty(false);
        }
      }}
      onChange={e => {
        setSearch(e.target.value);
        onChange(e.target.value);
      }}
      ref={inputRef}
      append={{
        className: styles.append,
        children: (
        <div className="d-flex align-items-center">
          <Button.Link onClick={handleClick}>
            <Sprite use="search" />
          </Button.Link>
          {(search || dirty) && (
            <Button.Link className="ms-3" onClick={handleReset}>
              <Sprite use="cancel" />
            </Button.Link>
          )}
        </div>
      )}}
      size="sm"
      fullWidth
      useFormik={false}
    />
  );
};

// EXPORT
export default SearchTool;
